import {GET_EXTENDED_COURSES} from "./actionTypes";

// eslint-disable-next-line 
export default (state = [], action) => {
    switch(action.type) {
        case GET_EXTENDED_COURSES :
            return action.payload;
        default:
            return state;  
    };
};